var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaybtn2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.997,
    height: 32.003,
    viewBox: "0 0 31.997 32.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,1.5A15.98,15.98,0,1,1,2.71,11.38a15.938,15.938,0,0,1,8.66-8.66A15.89,15.89,0,0,1,17.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,12.25a.424.424,0,0,1,.14-.06.772.772,0,0,1,.15-.02.59.59,0,0,1,.28.08l6.75,4.9a.637.637,0,0,1,.2.2.6.6,0,0,1,.08.29.566.566,0,0,1-.08.28.577.577,0,0,1-.2.21l-6.75,4.9a.555.555,0,0,1-.28.07.592.592,0,0,1-.29-.07.578.578,0,0,1-.2-.21.566.566,0,0,1-.08-.28v-9.8a.772.772,0,0,1,.02-.15.423.423,0,0,1,.06-.14.714.714,0,0,1,.2-.2Z",
    fill: "#4c2766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybtn2);
export default __webpack_public_path__ + "static/media/playbtn2.a1771e3ec5535b478019a75d1f36ff2f.svg";
export { ForwardRef as ReactComponent };